
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ContractPayDetailsApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'contract-pay-details'
  }

}
